import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["translator", "assetPath", "locale", "error", "errorDescription", "logoutLink", "tryAgainLink"];
import * as React from 'react';
import { Button } from '@gandi/ui';
import { Static } from '../Static';
var styles = {
  "pre": "Login-pre_3-cE1"
};
function Login(_ref) {
  var __ = _ref.translator.__,
    assetPath = _ref.assetPath,
    locale = _ref.locale,
    error = _ref.error,
    errorDescription = _ref.errorDescription,
    _ref$logoutLink = _ref.logoutLink,
    logoutLink = _ref$logoutLink === void 0 ? 'logout' : _ref$logoutLink,
    _ref$tryAgainLink = _ref.tryAgainLink,
    tryAgainLink = _ref$tryAgainLink === void 0 ? 'login' : _ref$tryAgainLink,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(Static, _extends({
      title: __('Identification error'),
      illustration: assetPath('img/Login.svg'),
      buttons: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        href: tryAgainLink,
        kind: "outline",
        grouped: true
      }, __('Try again')), /*#__PURE__*/React.createElement(Button, {
        href: logoutLink,
        grouped: true
      }, __('Log out')))
    }, extraProps), errorDescription && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, __('Sorry, an identification error occurred. ' + 'This is probably a temporary error.')), /*#__PURE__*/React.createElement("p", null, __('Please check the error messages below:')), /*#__PURE__*/React.createElement("pre", {
      className: styles.pre
    }, /*#__PURE__*/React.createElement("em", null, error), " ", errorDescription)), !errorDescription && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, __('Sorry, an identification error occurred and we were unable to ' + "authenticate the server's response.")), /*#__PURE__*/React.createElement("p", null, __('This is due to a malformed request, which could be a malicious ' + 'attempt to hijack your session. We recommend that you log out ' + 'as a precaution.')), /*#__PURE__*/React.createElement("p", null, __('Please click one of the buttons below to try again or logout. ' + 'You can safely log in again afterwards.'))))
  );
}
export default Login;